export default "__VITE_ASSET__BMFUfe6M__"